export default function isValueNullOrNegative(value) {
	return value === null || value < 0;
}



// WEBPACK FOOTER //
// ./src/core/utils/isValueNullOrNegative.js